module.exports = __webpack_public_path__ + "9a45c0466787492275a0d4974447bbe7.MP3";